// extracted by mini-css-extract-plugin
export default {"drawer":"drawer_drawer__d3oYo","open_drawer":"drawer_open_drawer__LV1GD"};